import { useEffect, useRef } from 'react';
import { sendFlowStartEvent } from './google-analytics';

type FlowStartWatcherProps = {
  dirty: boolean;
  formName: string;
  virtualPageUrl: string;
  options: {
    flowName?: string;
    pageUrl?: string;
  };
};

export const FlowStartWatcher = ({
  dirty,
  formName,
  virtualPageUrl,
  options,
}: FlowStartWatcherProps) => {
  const hasFired = useRef(false);

  useEffect(() => {
    if (dirty && !hasFired.current) {
      hasFired.current = true;
      sendFlowStartEvent(formName, virtualPageUrl, options);
    }
  }, [dirty]);

  return null;
};

